import { createContext } from 'react'

interface ExperienceSearchFilterDraft {
  queryParams: URLSearchParams;
  setQueryParams: (queryParams: URLSearchParams) => void;
}

// Only the mobile drawer supplies a draft. Other Experiences filters use the URL.
export default createContext<ExperienceSearchFilterDraft | undefined>(undefined)
